import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PurchaseCreditReportFAQ from "./PurchaseCreditReportFAQ";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import ErrorBoundary from "../../common/ErrorBoundary";
import PurchaseCreditReportDialogContainer from "./PurchaseCreditReportDialogContainer";
import { ApplicationState } from "../../../store";
import * as CSIDActions from "../../../store/csid/actions";
import { ICSIDUserStatus } from "../../../store/csid/types";
import IDFCreditAuthentication from "../Auth/IDFCreditAuthentication";


const PurchaseCreditReport = ({ changeTabCallback, purchaseDisabled }: any) => {
    const dispatch = useDispatch();
    const refreshL3Status = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus(true));

    const l3Status = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );

    const filteredProducts = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.oneTimeProducts ? state.loggedInUser.oneTimeProducts : []
    );
    const hasPurchase1B = filteredProducts.some(function (product: any) {
        return product.ServiceCode === "SVCLVL-TU-CRDRPT-SCORE" || product.ServiceCode === "SVCLVL-TU-CRDRPT";
    });
    const hasPurchase3B = filteredProducts.some(function (product: any) {
        return product.ServiceCode === "SVCLVL-TU-CRDRPT-3B-SCORE" || product.ServiceCode === "SVCLVL-TU-CRDRPT-3B";
    });

    const [selectedProduct, setSelectedProduct] = useState<any>(null);

    const getPrice = (serviceCode: string) => {
        const productData = filteredProducts.find(function (product: any) {
            return product.ServiceCode === serviceCode;
        });
        if (productData) {
            return productData.Price.toFixed(2);
        }
    };

    const getProduct = (serviceCode: string) => {
        const productObj = filteredProducts.find(function (product: any) {
            return product.ServiceCode === serviceCode;
        });
        if (productObj) {
            return productObj;
        }
    };

    const onClickProduct = (serviceCode: string) => {
        const productObj = getProduct(serviceCode);
        if (productObj) {
            setSelectedProduct(productObj);
        }
    };

    const closePurchaseCreditReportDialog = () => {
        setSelectedProduct(null);
    };

    const creditAuthSuccessCallBack = (callbackObj?: any) => {
        refreshL3Status();
    };

    return (
        <React.Fragment>
            {(l3Status?.["auth-status"]?.toUpperCase() === "LOCKED" || l3Status?.["auth-status"]?.toUpperCase() ==="L3-OTP-LOCKED") ? (
                <IDFCreditAuthentication
                    initCSIDUserStatus={l3Status as ICSIDUserStatus}
                    creditAuthCallback={creditAuthSuccessCallBack}
                    displayFlowAsDialog={true}
                />
            ) : (
                <>
                    <div className="row" id="content">
                        <div className="col-xs col-no-gutter">
                            <div className="row">
                                <div className="box offset-padding">
                                    <div>
                                        <div className="box-header">
                                            <div className="box-title-container">
                                                <div className="box-title-icon" aria-hidden="true">
                                                    <RenderIcons iconName="file-invoice-dollar" />
                                                </div>
                                                <div className="box-title-text">
                                                    <h2 className="box-title">Purchase Credit Report</h2>
                                                </div>
                                            </div>
                                        </div>
                                        {purchaseDisabled && (
                                            <div className="msg-generic msg-small margin-bottom-m">
                                                <i>
                                                    <em className="las la-info-circle"></em>{" "}
                                                </i>
                                                You can only purchase one report every 24 hours. You can{" "}
                                                <a
                                                    className="default_link"
                                                    href="#0"
                                                    onClick={(e: any) => {
                                                        e.preventDefault();
                                                        changeTabCallback("5");
                                                    }}
                                                >
                                                    view your latest report here.
                                                </a>
                                            </div>
                                        )}
                                        <div className="box-content purchase-report-content">
                                            {hasPurchase1B && (
                                                <div className="row between-xs">
                                                    <div className="col-gutter-vertical left-content">
                                                        <h3 className="content-title">TransUnion Credit Report</h3>
                                                        <div className="box-description">
                                                            <p>
                                                                Your credit report is full of valuable information that lenders check when you apply for credit
                                                                cards or loans, so you should know what's on there too.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="col-gutter-vertical align-center right-content">
                                                        {getPrice("SVCLVL-TU-CRDRPT-SCORE") && (
                                                            <div className="margin-bottom-l">
                                                                <button
                                                                    type="button"
                                                                    className="btn-default btn-primary btn-purchase-credit-report"
                                                                    onClick={() => onClickProduct("SVCLVL-TU-CRDRPT-SCORE")}
                                                                    disabled={purchaseDisabled ? true : false}
                                                                >
                                                                    <span className="btn-text">Get Report & Score - ${getPrice("SVCLVL-TU-CRDRPT-SCORE")}</span>
                                                                </button>
                                                            </div>
                                                        )}
                                                        {getPrice("SVCLVL-TU-CRDRPT") && (
                                                            <div className="">
                                                                <button
                                                                    type="button"
                                                                    className="btn-default btn-primary btn-purchase-credit-report"
                                                                    onClick={() => onClickProduct("SVCLVL-TU-CRDRPT")}
                                                                    disabled={purchaseDisabled ? true : false}
                                                                >
                                                                    <span className="btn-text">Get Report Only - ${getPrice("SVCLVL-TU-CRDRPT")}</span>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            {hasPurchase3B && (
                                                <>
                                                    {hasPurchase1B && <div className="line-divider margin-vertical-l"></div>}
                                                    <div className="row between-xs">
                                                        <div className="col-gutter-vertical left-content">
                                                            <h3 className="content-title">3-Bureau Credit Report</h3>
                                                            <div className="box-description">
                                                                <p>
                                                                    You have three separate credit reports & scores—one with each of the three national credit
                                                                    bureaus. They can all contain different information, and lenders can look at any or all of them
                                                                    when you apply for credit.
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-gutter-vertical align-center right-content">
                                                            {getPrice("SVCLVL-TU-CRDRPT-3B-SCORE") && (
                                                                <div className="margin-bottom-l">
                                                                    <button
                                                                        type="button"
                                                                        className="btn-default btn-primary btn-purchase-credit-report"
                                                                        onClick={() => onClickProduct("SVCLVL-TU-CRDRPT-3B-SCORE")}
                                                                        disabled={purchaseDisabled ? true : false}
                                                                    >
                                                                        <span className="btn-text">
                                                                            Get Report & Score - ${getPrice("SVCLVL-TU-CRDRPT-3B-SCORE")}
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {getPrice("SVCLVL-TU-CRDRPT-3B") && (
                                                                <div className="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn-default btn-primary btn-purchase-credit-report"
                                                                        onClick={() => onClickProduct("SVCLVL-TU-CRDRPT-3B")}
                                                                        disabled={purchaseDisabled ? true : false}
                                                                    >
                                                                        <span className="btn-text">Get Report Only - ${getPrice("SVCLVL-TU-CRDRPT-3B")}</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <PurchaseCreditReportFAQ />
                    {selectedProduct && (
                        <ErrorBoundary componentName="PurchaseCreditReportDialogContainer" type="showError" replaceDefaultContent={false} errorMsg="">
                            <PurchaseCreditReportDialogContainer
                                selectedProduct={selectedProduct}
                                onClose={closePurchaseCreditReportDialog}
                                changeTabCallback={changeTabCallback}
                            />
                        </ErrorBoundary>
                    )}
                </>
            )}
        </React.Fragment>
    );
};

export default PurchaseCreditReport;
